import { ContentType } from '@quromedical/fhir-common';
import { z } from 'zod';

export const ContentTypeSchema = z.nativeEnum(ContentType);

export const MediaDataSchema = z.object({
  title: z.string(),
  key: z.string(),
  contentType: ContentTypeSchema,
});

export type MediaData = z.infer<typeof MediaDataSchema>;
